/* AKTEPELER - ON BILGILENDIRME ONAYI (26 Eki 2026)
 *
 * NEDEN: Havale/EFT (Banka Mevduati) acilinca sitede siparis tamamlanabilir
 * oldu. Mesafeli Sozlesmeler Yonetmeligi md.7: tuketici (numune alicisi)
 * ON BILGILENDIRMEYI OKUDUGUNU TEYIT ETMELI; ispat yuku saticida (md.5/6).
 * Shopify temel pakette odeme sayfasina onay kutusu eklenemiyor, bu yuzden
 * teyit SEPETTE aliniyor (hukuk-nobetcisi onerisi).
 *
 * NASIL:
 *   - Kutu sepet ozetinde, odeme dugmesinin ustunde (snippets/cart-summary.liquid).
 *     Isaretsiz gelir.
 *   - Odeme dugmesine basilinca isaret yoksa gecis DURUR, hata gosterilir.
 *   - Isaret varsa onay zamani sepet ozniteligi olarak yazilir
 *     (/cart/update.js -> siparise "Ek ayrintilar" olarak duser = ispat kaydi),
 *     yazma bittikten sonra /checkout'a gidilir.
 *   - Sepeti atlayan hizli odeme dugmeleri temada kapatildi
 *     (blocks/buy-buttons.liquid, snippets/cart-summary.liquid).
 *
 * SINIR: istemci tarafi. Dogrudan /checkout adresine giden birini durdurmaz;
 * gercek alicinin gectigi yollari kapatir (MOQ kuraliyla ayni sinir).
 */
(function () {
  'use strict';

  var ANAHTAR = 'Ön bilgilendirme onayı';
  var onaylandi = false;     /* cekmece yeniden cizilince durumu korumak icin */
  var gidiyor = false;

  function kutular() {
    return Array.prototype.slice.call(document.querySelectorAll('.akt-onay__kutu'));
  }

  function hataGoster(kutu, goster) {
    var kap = kutu && kutu.closest('.akt-onay');
    if (!kap) return;
    kap.classList.toggle('akt-onay--hata', !!goster);
    var h = kap.querySelector('.akt-onay__hata');
    if (h) h.hidden = !goster;
  }

  function enYakinKutu(b) {
    var p = b, n = 0;
    while (p && n < 8) {
      var k = p.querySelector && p.querySelector('.akt-onay__kutu');
      if (k) return k;
      p = p.parentElement; n++;
    }
    var hepsi = kutular();
    return hepsi.length ? hepsi[0] : null;
  }

  function damgaYaz(deger) {
    var a = {};
    a[ANAHTAR] = deger;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: a })
    });
  }

  function zamanDamgasi() {
    var d = new Date();
    return d.toISOString() + ' (sepette kutu işaretlendi; ' +
      d.toLocaleString('tr-TR', { timeZone: 'Europe/Istanbul' }) + ')';
  }

  /* kutu degisince durumu tut, hatayi kaldir */
  document.addEventListener('change', function (e) {
    var k = e.target;
    if (!k || !k.classList || !k.classList.contains('akt-onay__kutu')) return;
    onaylandi = k.checked;
    kutular().forEach(function (x) { x.checked = onaylandi; });
    if (onaylandi) hataGoster(k, false);
    else damgaYaz('').catch(function () {});
  }, true);

  /* odeme dugmesi: tiklama ve form gonderimi */
  function engelle(e, b) {
    var k = enYakinKutu(b);
    if (!k) return;                       /* kutu yoksa (bos sepet) karisma */
    e.preventDefault();
    e.stopImmediatePropagation();
    if (!k.checked) {
      hataGoster(k, true);
      try { k.focus({ preventScroll: false }); } catch (x) { k.focus(); }
      return;
    }
    if (gidiyor) return;
    gidiyor = true;
    b.setAttribute('aria-busy', 'true');
    damgaYaz(zamanDamgasi())
      .then(function (r) { if (!r.ok) throw new Error('kaydedilemedi'); })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function () {
        gidiyor = false;
        b.removeAttribute('aria-busy');
        var kap = k.closest('.akt-onay');
        var h = kap && kap.querySelector('.akt-onay__hata');
        if (h) { h.textContent = 'Onay kaydedilemedi, lütfen tekrar deneyin.'; h.hidden = false; }
      });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[name="checkout"]');
    if (b) engelle(e, b);
  }, true);

  document.addEventListener('submit', function (e) {
    var b = e.submitter;
    if (b && b.getAttribute('name') === 'checkout') engelle(e, b);
  }, true);

  /* ESKI DAMGA: /cart/clear.js oznitelikleri silmiyor (teknik-nobetci 26.10).
     Sayfa acildiginda kutu isaretli degilse onceki onay damgasi temizlenir;
     boylece kutu yeniden isaretlenmeden eski damga siparise dusmez.
     Kutu yalniz dolu sepette basildigi icin istek yalniz o zaman gider. */
  function eskiDamgayiSil() {
    if (!kutular().length || onaylandi) return;
    fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (c && c.attributes && c.attributes[ANAHTAR] && !onaylandi) return damgaYaz('');
      })
      .catch(function () {});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', eskiDamgayiSil, { once: true });
  } else {
    eskiDamgayiSil();
  }

  /* Horizon sepet ozetini AJAX ile yeniden ciziyor: isaret durumunu geri koy */
  function geriKoy() {
    if (!onaylandi) return;
    kutular().forEach(function (x) { if (!x.checked) x.checked = true; });
  }
  if (typeof MutationObserver !== 'undefined') {
    var bekl = false;
    var g = new MutationObserver(function () {
      if (bekl) return;
      bekl = true;
      requestAnimationFrame(function () { bekl = false; geriKoy(); });
    });
    var bas = function () { g.observe(document.body, { childList: true, subtree: true }); };
    if (document.body) bas(); else document.addEventListener('DOMContentLoaded', bas, { once: true });
  }
})();
